<template lang="html">
  <div id="floorplan-detail-specs" class="tc mv3 b f4-ns f5 ttu">
    <!-- Beds + Baths -->
    <div class="beds-baths">
      <span>{{ plan.type.label }}</span>,
      <span class="baths">{{ baths }} BATH</span><span v-if="baths > 1">S</span>
    </div>

    <!-- Collection -->
    <div class="collection mt2">
      {{ collection }} COLLECTION
    </div>

    <!-- Separator -->
    <hr class="w4 bg-black mv4" />

    <!-- Sizes -->
    <div class="sizes">
      <!-- Interior -->
      <span class="interior mr3 dib">
        <span class="f3 font-futura-bold">{{ interior }}</span>
        <span class="f6 label tracked">SQ.FT. INTERIOR</span>
      </span>
      <!-- Exterior -->
      <span class="exterior" v-if="exterior > 0">
        <span class="f3 font-futura-bold">{{ exterior }}</span>
        <span class="f6 label tracked">SQ.FT. EXTERIOR</span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FloorplanMixin from '../FloorplanMixin';

export default {
  name: 'floorplan-detail-specs',
  mixins: [FloorplanMixin],
  props: {
    plan: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      projectId: 'adhocId'
    }),
    baths() {
      return this.plan.baths;
    },
    beds() {
      return this.numBedsByType(this.plan.type.slug);
    },
    collection() {
      return this.directionBySlug(this.plan.exposure[0]);
    },
    interior() {
      return this.plan.interior;
    },
    exterior() {
      return this.plan.exterior;
    }
  },
  mounted() {
    this.$ma.trackEvent({
      action: 'ViewedFloorplan',
      properties: {
        project: this.projectId,
        floorplanName: this.plan.name,
        floorplanInterior: this.plan.interior,
        floorplanType: this.plan.type.slug
      }
    });
  },
  updated() {
    this.$ma.trackEvent({
      action: 'CycledFloorplan',
      properties: {
        project: this.projectId,
        floorplanName: this.plan.name,
        floorplanInterior: this.plan.interior,
        floorplanType: this.plan.type.slug
      }
    });
  }
};
</script>

<style lang="scss">
#floorplan-detail-specs {
  letter-spacing: 0.2rem;

  hr {
    height: 1px;
  }

  .sizes {
    letter-spacing: normal;
    span {
      vertical-align: bottom;
      &.label {
        display: inline-block;
        margin-bottom: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailSpecs.vue